import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { ConfigService } from '../../../../core';
import { ConfigEmpresa } from '../../../configuracoes/app/empresa';
import { isModoCentralCompraCadastro } from '../../../../models/modo-central-compra';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { pessoaFisica, pessoaJuridica, pessoaCentralCompras } from '../pessoa-tipo';

@Component({
    selector: 'sgt-pessoa-tipo-multiselect',
    templateUrl: './pessoa-tipo-multiselect.component.html',
    styleUrls: ['./pessoa-tipo-multiselect.component.less']
})
export class PessoaTipoMultiselectComponent implements OnInit {
    private configEmpresa: ConfigEmpresa;

    /** Tipos selecionados */
    @Input() tipos: number[];
    /** Ao alterar a seleção dos tipos */
    @Output() tiposChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Tipo';
    @Input() checked = 'Tipo'
    @Input() checkedPlural = 'Tipos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowPessoaFisica = true;
    @Input() isShowPessoaJuridica = true;
    @Input() isShowPessoaCentralCompras = true;

    // Options
    options: IMultiSelectOption[];

    constructor(private configService: ConfigService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();

        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pessoa-tipo ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowPessoaFisica) {
            selects.push({
                id: pessoaFisica.id,
                name: pessoaFisica.nome,
                classes: 'multiselect-item-pessoa-tipo multiselect-item-pessoa-tipo-pessoa-fisica'
            });
        }
        if (this.isShowPessoaJuridica) {
            selects.push({
                id: pessoaJuridica.id,
                name: pessoaJuridica.nome,
                classes: 'multiselect-item-pessoa-tipo multiselect-item-pessoa-tipo-pessoa-juridica'
            });
        }
        if (isModoCentralCompraCadastro(this.configEmpresa.modoCentralCompra) && this.isShowPessoaCentralCompras) {
            selects.push({
                id: pessoaCentralCompras.id,
                name: pessoaCentralCompras.nome,
                classes: 'multiselect-item-pessoa-tipo multiselect-item-pessoa-tipo-pessoa-central-compras'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção dos tipos */
    onChange() {
        this.tiposChange.emit(this.tipos);
    }
}
